<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  created: function () {
    this.$store.dispatch('user/initApp');
  }
};
</script>

<style>
.flex_around {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

* {
  padding: 0;
  margin: 0;
  list-style: none;
  text-decoration: none;
	box-sizing: border-box;
}

:root {
  --el-color-primary: #61AC85;
  --page-gutter: 16px;
  --page-gutter-wide: 16px;
}

@media (min-width: 768px) {
  :root {
    --page-gutter: 40px;
    --page-gutter-wide: 48px;
  }
}

@media (min-width: 1280px) {
  :root {
    --page-gutter: 162px;
    --page-gutter-wide: 160px;
  }
}

@media (min-width: 1600px) {
  :root {
    --page-gutter-wide: 320px;
  }
}

a:link,
a:visited {
  color: #424242;
}

html,
body {
  width: 100%;
  overflow-x: hidden;
}

body {
  background-color: #FFFFFF;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
  /*#2c3e50;*/
}

/* 隐藏number输入框的加减符号 */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* 针对Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

input {
  border: none;
  /* 完全移除边框 */
  outline: none;
  /* 移除聚焦时的轮廓线（可选） */
}

textarea {
  border: none;
  /* 完全移除边框 */
  outline: none;
  /* 移除聚焦时的轮廓线（可选） */
}

/* 分页当前页背景 */
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #000000;
  color: #ffffff;
}

.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #000000;
}

.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
  color: #ffffff;
}

/*@font-face {
    font-family: wenyuexinqingnian;
    src: url('../static/wenyuexinqingnian.ttf');
}
@font-face {
  font-family:WenYueSXSQiuYiNongTi;
  src: url('../static/WenYueSXSQiuYiNongTi.otf');
}*/
</style>


// WEBPACK FOOTER //
// src/App.vue